export enum AcEnumDDTableRowEvent {
    afterDelete = "after_delete",
    afterFormat = "after_format",
    afterInsert = "after_insert",
    afterModify = "after_modify",
    afterSave = "after_save",
    afterUpdate = "after_update",
    beforeDelete = "before_delete",
    beforeFormat = "before_format",
    beforeInsert = "before_insert",
    beforeModify = "before_modify",
    beforeSave = "before_save",
    beforeUpdate = "before_update",
    unknown = "unknown"
}
